import { render, staticRenderFns } from "./gradebook.vue?vue&type=template&id=06fbe8b1&scoped=true&"
import script from "./gradebook.vue?vue&type=script&lang=js&"
export * from "./gradebook.vue?vue&type=script&lang=js&"
import style0 from "./gradebook.vue?vue&type=style&index=0&id=06fbe8b1&prod&lang=css&"
import style1 from "./gradebook.vue?vue&type=style&index=1&id=06fbe8b1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fbe8b1",
  null
  
)

export default component.exports